import { getBatteryIconStatus } from 'src/helpers/virtual_helpers/virtual_icons_helpers';
//Types
import type { VirtualComponentInterfaceData, VCInterfaceStatus } from 'src/types/VirtualComponents';

export const updateHeimanCo2Sensor = (
	interface_data: VCInterfaceStatus[],
	data: VCInterfaceStatus,
	valueData: VirtualComponentInterfaceData,
): void => {
	const { role } = data;
	data.hasAction = false;
	data.hideLabel = /^(has_alarm)$/.test(role);
	if (/^(battery_percentage)$/.test(role)) {
		const batteryIcon = getBatteryIconStatus(valueData.value);
		data.icon = batteryIcon.icon;
		if (batteryIcon.iconStyle) data.iconStyle = batteryIcon.iconStyle;
		if (batteryIcon.iconColor) data.iconColor = batteryIcon.iconColor;
	} else if (/^(mute_alarm)$/.test(role)) {
		data.icon = `fas fa-volume${valueData.value ? '-slash' : ''}`;
		data.value = null;
	} else if (/^(ppm)$/.test(role)) {
		data.mainLabel = true;
		data.iconColor = '--color-success';
		if (valueData.value >= 2000) {
			data.iconColor = '--color-danger';
		} else if (valueData.value >= 1000) {
			data.iconColor = '--color-warning';
		}
	}
	interface_data.push(data);
};
